export const BADGE_SIZE = ['small', 'medium'] as const;
export type TBadgeSize = (typeof BADGE_SIZE)[number];
